import moment from 'moment'
import CloneDeep from 'lodash/cloneDeep'
import automations from 'mixins/automations'

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

import ApplicationApi from '@/api/applicationApi'
const apiApplication = new ApplicationApi

import { QuestionFile } from '@/types/commonFile.js'

import { tenderMixin, storageMixin, innerChatMixin } from 'mixins'

export default {
  data() {
    return {
      localKey: null,
      loading: false,
      comments: [],
      history: [],
      questions: [],
      agreements: [],
      tennderInfoTab: 0,
      historyDialogProps: {
        open: false,
        itemId: null
      },
      sprHistory: {
        additionalFields: []
      }
    }
  },
  mixins: [ tenderMixin, storageMixin, innerChatMixin, automations ],
  methods: {
    /**
     * Получение истории согласования
     */
    async $_getAgreementsHistory() {
      this.loading = true
      const getStoryAgreementsHistory = this.$can('set', 'useCommonAgreements')
        ? 'tenderStageAgreeHistory'
        : 'tenderAgreeHistory'
      const tenderId = +this.$route.params.id || +this.$route.query.id
      if (!tenderId) {
        return
      }

      await this.$store.dispatch(getStoryAgreementsHistory, tenderId )
        .then(res => {
          if (res?.length ) {
            this.agreements = res
          } else {
            this.agreements = []
          }
        })
        .catch(res => this.$log_error(res))
        .finally(() => this.loading = false)

    },
    /**
     * Получаем и заполняем историю по тендеру
     */
    async $_getTenderHistory() {
      this.loading = true
      await api.tenderEventHistory(Number(this.tenderId))
        .then(async res => {
          if (res) {
            if (res?.some(i => i.eventType === 'AUTOMATION' && i.parameters.includes('UPDATE_ADDITIONAL_FIELD'))) {
              await this.$_getAdditionalFields()
                .then(async () => {
                  this.sprHistory.additionalFields = this.mixin_additionalFields.items
                })
            }

            this.history = res.sort((a, b) => {
              return moment(a.dateAdded).format('x') - moment(b.dateAdded).format('x')
            })
          } else {
            this.history = []
          }
        })
        .catch(res => this.$log_error(res))
        .finally(() => this.loading = false)
    },
    /**
     * Получаем и заполняем вопросы/ответы организатору
     */
    async $_getTenderComment() {
      if (this.type == 'TENDER' && this.tenderId) {
        this.loading = true
        await api.tenderComments(Number(this.tenderId))
          .then(res => {
            if (res?.data?.tenderComments?.length) {
              this.comments = this.$_convertComments(res.data.tenderComments)
            } else {
              this.comments = []
            }
          })
          .catch(res => this.$log_error(res))
          .finally(() => this.loading = false)
      }
    },
    /**
     * Конвертируем массив вопросов от поставщиков в нормальный вид вопрос-ответ в разрезе поставщиков
     */
    $_convertComments(model) {
      if (!model?.length) { return [] }

      const organizationIds = model.map(i => i.organizationId).filter((v, i, a) => a.indexOf(v) === i)

      const result = []
      const fakeUsers = []
      const fakeOrganizationIds = []

      organizationIds.forEach((organizationId) => {
        const questionsByParticpant = model.filter(i => i.organizationId === organizationId)
          .sort((a, b) => {
            return this.$moment(this.$moment(a.question.sentTime).format('x') - b.question.sentTime).format('x')
          })

        questionsByParticpant.forEach((questionByParticpant) => {
          if (!questionByParticpant.question.contact?.userName) {
            let userIndex = fakeUsers.findIndex((item) => item === questionByParticpant.question.contact.participantUserId)
            if (userIndex === -1) {
              fakeUsers.push(questionByParticpant.question.contact.participantUserId)
              userIndex = fakeUsers.length - 1
            }
            questionByParticpant.question.contact.userName = `${this.$t('Tenders.Member')} ${userIndex + 1}`
          }
          if (!questionByParticpant.organizationTitle) {
            let organizationIndex = fakeOrganizationIds.findIndex((item) => item === questionByParticpant.organizationId)

            if (organizationIndex === -1) {
              fakeOrganizationIds.push(questionByParticpant.organizationId)
              organizationIndex = fakeOrganizationIds.length - 1
            }
            questionByParticpant.organizationTitle = `${this.$t('Common.Organization')} ${organizationIndex + 1}`
          }
        })

        const participantOrgQuestions = {
          organizationId: organizationId,
          organizationTitle: questionsByParticpant[0].organizationTitle,
          lastDateQuestion: new Date(Math.max(...questionsByParticpant.map(i => new Date(i.question.sentTime)))),
          needBadge: !!questionsByParticpant.find(i => !i.answer?.message),
          questions: questionsByParticpant,
          questionTime: questionsByParticpant[0].question.sentTime,
        }

        result.push(participantOrgQuestions)

      })
      return result.sort((a, b) => {
        return this.$moment(this.$moment(b.questionTime).format('x') - a.questionTime).format('x')
      })
    },
    /**
     * Получаем и заполняем вопросы поставщикам
     */
    async $_getTenderQuestions() {
      if (this.type == 'TENDER' && this.$can('set', 'privateMessageToBidder')) {
        this.questions = []
        this.loading = true
        await apiApplication.getTenderQuestions(Number(this.tenderId))
          .then(res => {
            if (res) {
              this.questions = this.$_convertQuestions(res)
            } else {
              this.questions = []
            }
          })
          .catch(res => {
            this.$log_error(res)
          })
          .finally(() => this.loading = false)
      }
    },
    $_convertQuestionAttachments(attachments) {
      if (!attachments?.length) { return [] }
      const result = []
      attachments?.forEach((attachment) => {
        result.push(new QuestionFile(attachment))
      })
      return result
    },
    /**
     * Конвертируем массив вопросов от организатора в нормальный вид вопрос-ответ в разрезе поставщиков
     */
    $_convertQuestions(model) {
      if (!model) { return [] }
      const allParticpantOrganizationIds = model.map(i => i.addedContacts.map(ii => ii.addedContact.organizationId))
      const particpantOrganizationIds = [].concat.apply([], allParticpantOrganizationIds).filter((v, i, a) => a.indexOf(v) === i)

      const result = []

      particpantOrganizationIds.forEach(particpantOrganizationId => {
        const questionsByParticpant = model.filter(i => i.addedContacts
          .find(ii => ii.addedContact.organizationId === particpantOrganizationId))
          .sort((a, b ) => {
            return this.$moment(this.$moment(a.modifiedDate).format('x') - b.modifiedDate).format('x')
          })

        const particpant = questionsByParticpant[0].addedContacts.find(i => i.addedContact.organizationId === particpantOrganizationId)

        const participantOrgQuestions = {
          particpantOrganizationId: particpant.addedContact.organizationId,
          particpantOrganizationTitle: particpant.addedContact.organizationTitle,
          lastDateQuestion: new Date(Math.max(...questionsByParticpant.map(i => new Date(i.modifiedDate)))),
          questions: []
        }

        questionsByParticpant
          .sort((a, b) => (this.$moment(b.modifiedDate) < this.$moment(a.modifiedDate) ? 1 : -1))
          .forEach((questionByParticpant) => {

            const particpantContact = questionByParticpant.addedContacts.find(i => i.addedContact.organizationId === particpantOrganizationId)

            particpantContact.answers?.forEach((answer, answerIndex) => {
              particpantContact.answers[answerIndex].attachments = this.$_convertQuestionAttachments(particpantContact.answers[answerIndex].attachments)
            })

            questionByParticpant.attachments = this.$_convertQuestionAttachments(questionByParticpant.attachments)

            participantOrgQuestions.questions.push(
              {
                questionId: questionByParticpant.questionId,
                sendTime: questionByParticpant.sendTime,
                modifiedDate: questionByParticpant.modifiedDate,
                message: questionByParticpant.message,
                orgContact: questionByParticpant.questionContact,
                attachments: questionByParticpant.attachments,
                particpantContact: particpantContact,
                answers: particpantContact.answers,
              })
          })
        result.push(participantOrgQuestions)
      })
      return result.sort((a, b ) => {
        return this.$moment(this.$moment(b.lastDateQuestion ).format('x') - a.lastDateQuestion).format('x')
      })
    },
    getProps() {
      this.localKey = `historyState_${this.type}`

      if (this.type === 'TENDER') {
        this.localKey = `historyState_tender_${this.tenderId}`
      } else if (this.type === 'LOT') {
        this.localKey = `historyState_lot_${this.item?.lotId || ''}`
      }

      const localValue = this.$_getPropFromLocalStorage(this.localKey,
        {
          dialog: {
            open: false,
            itemId: null
          },
          tab: 0
        },
        true)

      this.tennderInfoTab = localValue.tab
      this.historyDialog = localValue.dialog
      this.$_getTenderComment()
      if (this.$can('set', 'privateMessageToBidder')) { this.$_getTenderQuestions() }
      if (this.tenderId) {
        const newModel = CloneDeep(this.innerChat)
        newModel.chatKey = (this.tenderId)?.toString()

        this.$store.dispatch('innerChat/setModelInnerChat', {model: newModel})
        this.$_getInnerChat({
          entityId: newModel.chatKey,
          entityType: 'Tender'
        }, true)
      }
    }
  },
  computed: {
    tenderId() {
      return this.item?.tenderId || this.tender?.tenderId || this.$route.params.id
    },
    /**
     * Свойство подписки для внутреннего чата
     */
    subscribleEntity() {
      return {
        entityType: 'Tender',
        entityId: (this.tender?.tenderId || this.item?.tenderId)?.toString()
      }
    },
    $_tabs() {
      let tabs = []
      if (this.type == 'TENDER') {
        tabs.push(
          {
            name: this.$t('Common.Chat'),
            value: 'innerChat',
            showDialog: true,
            valueItems: this.innerChat,
            count: this.innerChat.unreadCount < 0 ? 0 : this.innerChat.unreadCount,
            badge: {
              dot: true,
              offsetX: 15,
              offsetY: 15,
            },
            tabIcon: 'comment',
            component: 'HistoryInnerChat'
          }
        )
        tabs.push(
          {
            name: this.$t('Tenders.Comment'),
            value: 'comments',
            showDialog: true,
            items: this.comments,
            count: this.comments.filter(comm => comm.needBadge)?.length,
            badge: {
              dot: true,
              offsetX: 15,
              offsetY: 15,
            },
            tabIcon: 'comment_u',
            component: 'CommentHistory'
          })
        if (this.$can('set', 'privateMessageToBidder')) {
          tabs.push({
            name: this.$t('Tenders.Questions'),
            value: 'questions',
            showDialog: true,
            items: this.questions,
            count: 0, // TODO: будет признак просмотра, тогда включим !!this.questions.filter(comm => comm.questions.find(i => !i.answers?.length))?.length,
            badge: {
              dot: true,
              offsetX: 15,
              offsetY: 15,
            },
            tabIcon: 'comment_q',
            component: 'QuestionsHistory'
          })
        }
        tabs.push(
          {
            name: this.$t('Tenders.History'),
            value: 'history',
            showDialog: true,
            items: this.history,
            badge: {},
            spr: this.sprHistory,
            tabIcon: 'time-ending',
            component: 'EventHistory'
          },
          {
            name: this.$t('Purchasing.Approval'),
            value: 'agreement',
            showDialog: true,
            items: this.agreements,
            badge: {},
            tabIcon: 'person-card',
            component: 'AgreementsHistory'
          }
        )
      }
      return tabs
    },
    currentSubscription() {
      if (!this.subscriptions?.Tender || !this.tenderId) {
        return {}
      }
      return this.subscriptions?.Tender?.[this.tenderId?.toString()] || {}
    }
  },
  watch: {
    historyDialogProps: {
      deep: true,
      handler(newValue) {
        if (this.localKey) {
          this.$_savePropToLocalStorage(this.localKey, {dialog: newValue, tab: this.tennderInfoTab}, true)
        }
      }
    },
    tenderId(newValue) {
      if (newValue) {
        this.getProps()
      }
    }
  },
}
